import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"

const useStyles = makeStyles((theme) => ({
	aiChip: {
		borderRadius: 4,
		...ColorUtil.getBackgroundAndContrastColor(colors.purple[100]),
		border: `1px solid ${colors.purple[300]}`
	},
	aiChipLabel: {
		height: "100%",
		width: "100%",
		padding: "2px 4px",
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between"
	},
	aiChipSmallSize: {
		height: theme.spacing(2),
		width: theme.spacing(4.5)
	},
	aiChipIconSmallSize: {
		width: theme.spacing(1.5),
		height: theme.spacing(1.5)
	},
	aiChipTextSmallSize: {
		fontSize: 12
	},
	aiChipMediumSize: {
		height: theme.spacing(2.5),
		width: theme.spacing(5.5)
	},
	aiChipIconMediumSize: {
		width: theme.spacing(2),
		height: theme.spacing(2)
	},
	aiChipTextMediumSize: {
		fontSize: 14
	}
}))

export default useStyles
